@use '../../styles/responsive';

$component-name: 'box';

.box {
  --ixf-box-background-color: none;

  position: relative;
  background-color: var(--ixf-box-background-color);

  @include responsive.responsive-props($component-name, 'border-radius', 'border-radius', false, false);
  @include responsive.responsive-props($component-name, 'flex', 'flex', false, false);
  @include responsive.responsive-props($component-name, 'max-width', 'max-width', false, false);
  @include responsive.responsive-props($component-name, 'min-width', 'min-width', false, false);
  @include responsive.responsive-props($component-name, 'padding-left', 'padding-left');
  @include responsive.responsive-props($component-name, 'padding-right', 'padding-right');
  @include responsive.responsive-props($component-name, 'padding-top', 'padding-top');
  @include responsive.responsive-props($component-name, 'padding-bottom', 'padding-bottom');
  @include responsive.responsive-props($component-name, 'position', 'position', false, false);
  @include responsive.responsive-props($component-name, 'overflow', 'overflow', false, false);
}
